 (function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ClientOpportunityAddEdit',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		// handle stage changes
		$('#clientopportunityaddedit-client_opportunity_stage_id').on('change', function click(e)
		{
			var selected_val                       = $(this).val(),
			    $closed_result                     = $('#clientopportunityaddedit-client_opportunity_closed_result_id'),
			    $closed_result_note                = $('#clientopportunityaddedit-client_opportunity_closed_result_note'),
			    $closed_result_purchased_with      = $('#clientopportunityaddedit-client_opportunity_purchased_with'),
			    $closed_result_purchased_elsewhere = $('#clientopportunityaddedit-client_opportunity_closed_result_purchased_elsewhere');

			// reset "closed result" fields by default
			$('.closed-result-fields').addClass('hidden');
			$('.purchased-with-fields').addClass('hidden');
			$('.purchased-elsewhere-field').addClass('hidden');

			$closed_result.val('');
			$closed_result_note.val('');
			$closed_result_purchased_with.val('');
			$closed_result_purchased_elsewhere.val('');

			// get the stage record to determine if it's a "final" stage to show "closed results" fields
			Adzuki.Ajax.get('/ClientOpportunities/getStageById/' + selected_val).then(function success(stage) {
				if (stage.type === 'closed') {
					$('.closed-result-fields').removeClass('hidden');
				}
			});
		});

		// handle closed result changes
		$('#clientopportunityaddedit-client_opportunity_closed_result_id').on('change', function click(e)
		{
			var selected_val                       = $(this).val(),
			    $closed_result_purchased_with      = $('#clientopportunityaddedit-client_opportunity_purchased_with'),
			    $closed_result_purchased_elsewhere = $('#clientopportunityaddedit-client_opportunity_closed_result_purchased_elsewhere');

			// reset "purchased with" fields by default
			$('.purchased-with-fields').addClass('hidden');
			$('.purchased-elsewhere-field').addClass('hidden');

			$closed_result_purchased_with.val('');
			$closed_result_purchased_elsewhere.val('');

			// get the closed result record to determine if it's a "create task" result and if it's the "purchased elsewhere" result
			Adzuki.Ajax.get('/ClientOpportunities/getClosedResultById/' + selected_val).then(function success(closed_result) {
				// have to use id, not ideal, but these SHOULD NOT change often...
				if (closed_result.id === '5') {
					$('.purchased-with-fields').removeClass('hidden');
				}

				// display "create task" fields if result is flagged as such
				if (closed_result.create_task === '1') {
					// select the "Yes" option
					$('#clientopportunityaddedit-create_task-0').prop('checked', true);
					$('#clientopportunityaddedit-create_task-1').prop('checked', false);

					$('.create-task-no').removeClass('active');
					$('.create-task-yes').addClass('active');

					// toggle task fields
					$('.opportunity-task').removeClass('hidden');
				} else {
					// toggle task fields
					$('.opportunity-task').addClass('hidden');

					// select the "No" option
					$('.create-task-no').addClass('active');
					$('.create-task-yes').removeClass('active');

					$('#clientopportunityaddedit-create_task-0').prop('checked', false);
					$('#clientopportunityaddedit-create_task-1').prop('checked', true);
				}
			});
		});

		// handle purchased with changes
		$('#clientopportunityaddedit-client_opportunity_purchased_with').on('change', function click(e)
		{
			var selected_val                       = $(this).val(),
			    $closed_result_purchased_elsewhere = $('#clientopportunityaddedit-client_opportunity_closed_result_purchased_elsewhere');

			// reset "purchased elsewhere" field by default
			$('.purchased-elsewhere-field').addClass('hidden');

			$closed_result_purchased_elsewhere.val('');

			if (selected_val === 'supplier') {
				// set the "purchased elsewhere" value
				$closed_result_purchased_elsewhere.val('Direct with Supplier');
			} else if (selected_val === 'other') {
				// other selected, clear the field and display it
				$closed_result_purchased_elsewhere.val();

				$('.purchased-elsewhere-field').removeClass('hidden');
			}
		});

		// projections logic
		$('input[type=radio][name="form_component_data[ClientOpportunityAddEdit][enter_projections]"]').on('change', function click(e)
		{
			$('.opportunity-projections').toggleClass('hidden');
		});

		$('.client-opportunity-add-edit .component-toggle :checkbox').on('change', function click(e)
		{
			var $self          = $(this),
			    $ele_container = $('#value_container_' + $self.val()),
			    $amt_input     = $ele_container.find('.travel-type-value');

			$ele_container.toggleClass('hidden');
			$amt_input.val(0.00);

			toggleComponentValues();
			calculateTravelTypeTotal();
		});

		$('.client-opportunity-add-edit .travel-type-value').on('keyup cut paste', function click(e)
		{
			calculateTravelTypeTotal();
		});

		$('.client-opportunity-add-edit .travel-type-value').on('focus', function click(e)
		{
			var default_value = 0,
			    current_value = parseFloat($(this).val());

			if (current_value === default_value) {
				$(this).val('');
			}
		});

		// task logic
		$('input[type=radio][name="form_component_data[ClientOpportunityAddEdit][create_task]"]').on('change', function click(e)
		{
			$('.opportunity-task').toggleClass('hidden');
		});

		// toggle client recap box
		$('#client_recap').on('click', function onToggleClick(e)
		{
			var $self = $(this);
			$self.toggleClass('plus');
			$self.toggleClass('minus');

			$('.client-recap').collapse('toggle');
		});

		// for "sneek peek" on reservation list
		$('.reservation-peek').on('click', '.reservation-details', function showReservationDetails(e)
		{
			var $modal = $(".modal");

			e.preventDefault();
			$modal.find('.modal-body').text('Loading reservation details...');
			$modal.find('.modal-title').text('Reservation Details');
			$modal.modal('show');

			Adzuki.Ajax.get('/Reservations/reservationDetailsModal/'+$(this).data('reservation-id'))
			.then(function showDetails(data) {
				$modal.find('.modal-body').html(data);
			});
		});

		$("a.info-link").on('click', function showInfo(e)
		{
			var $self  = $(this),
			    $modal = $(".modal"),
			    body   = $self.data('content') || $($self.data('modal-id')).html();

			e.preventDefault();
			$modal.find('.modal-title').text($self.data('modal-title'));
			$modal.find('.modal-body').html(body);
			$modal.modal('show');
		});

		function toggleComponentValues()
		{
			var one_checked = false;

			$('.client-opportunity-add-edit .component-toggle :checkbox').each(function cbIterate(i, input) {
				if (this.checked) {
					one_checked = true;
					return;
				}
			});

			if (one_checked) {
				$('.client-opportunity-add-edit .estimated-prices').removeClass('hidden');
			} else {
				$('.client-opportunity-add-edit .estimated-prices').addClass('hidden');
			}
		}

		function calculateTravelTypeTotal()
		{
			var total          = 0.00,
			    decimal_length = 2;

			$('.client-opportunity-add-edit .travel-type-value').each(function iterate(i, input) {
				var $self   = $(this),
				    fld_val = 0.00,
				    float   = parseFloat($self.val());

				if (float > 0) {
					fld_val = float;
				}

				total = (parseFloat(total) + fld_val);
			});
			$('#clientopportunityaddedit-total_value').val(total.toFixed(decimal_length));
		}
	};
}(jQuery, window.Adzuki || {}));
